import { NotesTabContext } from "../../formability/formSubmission/enums/notesTabContext";
import CodeMirrorEditor from "~/helpers/codeMirrorEditor";

/**
 * Required: formSubmission prop in component for form submission notes
 */
export default {
  props: {
    context: {
      type: Number,
    }
  },
  data: function (): object {
    return {
      NotesTabContext,
      isPosting: false,
      applicationId: "",
      newNote: {
        text: '',
        author_id: null,
        form_submission_id: null,
        entry_id: null,
        detail_view_id: null,
        list_view_id: null,
      }
    };
  },
  computed: {
    canAdd(): boolean {
      return !this.isPosting && this.newNote.text.trim().length > 0;
    },
  },
  methods: {
    add(): void {
      if (!this.canAdd) {
        return;
      }
      this.isPosting = true;
      let action;
      if (this.context === NotesTabContext.Records) {
        const referrer = !!this.newNote.detail_view_id ? {detail_view_id: this.newNote.detail_view_id} : {list_view_id: this.newNote.list_view_id};
        action = this.$store.dispatch('noteStore/addEntryNote', {noteJson: this.newNote, referrer, entry: this.objectModelEntry});
      } else if (this.context === NotesTabContext.Submissions) {
        action = this.$store.dispatch('formSubmissionNoteStore/addSubmissionNote', {formSubmission: this.formSubmission, noteJson: this.newNote, referrer: {form_submission_id: this.newNote.form_submission_id}});
      }
      action.then(() => this.$emit('add-note'))
        .finally(() => this.resetAdd());
    },
    resetAdd(): void {
      this.newNote.text = '';
      this.isPosting = false;
      this.resetCodeMirrorText();
    },
    resetCodeMirrorText(): void {
      const editor: CodeMirrorEditor = this.$children.find(comp => comp["editor"] instanceof CodeMirrorEditor ).editor
      editor.codeMirror.setValue('')
      $(document).trigger('createNote:clear');
    }
  }
}